export default "__VITE_ASSET__rPd6lnit__";